"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parsePhoneBeforeSend = exports.mapObjCountriesCodes = exports.normalizePhoneBeforeInsert = exports.removeSymbolsFromPhone = exports.phoneMaxLength = exports.phoneMinLength = void 0;
const phone_1 = require("../constants/phone");
const disableLetters = phone => phone && phone.replace(/[^0-9-()\s]+/, '');
const phoneMinLength = min => phone => {
    if (!phone) {
        return undefined;
    }
    const phoneWithoutPhoneCode = (0, exports.removeSymbolsFromPhone)(phone);
    const isInvalidPhone = (phone.length && !phoneWithoutPhoneCode.length) || (phoneWithoutPhoneCode && phoneWithoutPhoneCode.length < min);
    return isInvalidPhone ? `Min ${min} characters allowed` : undefined;
};
exports.phoneMinLength = phoneMinLength;
const phoneMaxLength = max => phone => {
    if (!phone) {
        return undefined;
    }
    const phoneWithoutPhoneCode = (0, exports.removeSymbolsFromPhone)(phone);
    const isInvalidPhone = (phone.length && !phoneWithoutPhoneCode.length) || (phoneWithoutPhoneCode && phoneWithoutPhoneCode.length > max);
    return isInvalidPhone ? `Min ${max} characters allowed` : undefined;
};
exports.phoneMaxLength = phoneMaxLength;
const removePhoneCodeFromPhone = (phoneWithCode, iso = phone_1.USA_ISO) => {
    if (!phoneWithCode) {
        return '';
    }
    const code = phone_1.ISO_CODE[iso];
    return phoneWithCode.slice(code.length);
};
const parsePhoneBeforeShow = (phoneWithoutCode, iso) => {
    if (!phoneWithoutCode)
        return '';
    if (phoneWithoutCode[0] === '+') {
        phoneWithoutCode = removePhoneCodeFromPhone(phoneWithoutCode, iso);
    }
    phoneWithoutCode = (0, exports.removeSymbolsFromPhone)(phoneWithoutCode);
    if (iso === phone_1.USA_ISO) {
        phoneWithoutCode =
            '(' + phoneWithoutCode.slice(0, 3) + ') ' + phoneWithoutCode.slice(3, 6) + '-' + phoneWithoutCode.slice(6);
        return phoneWithoutCode;
    }
    return phoneWithoutCode;
};
const removeSymbolsFromPhone = phone => phone && phone.replace(/\(|\)|-|\s/gi, '');
exports.removeSymbolsFromPhone = removeSymbolsFromPhone;
const normalizePhoneBeforeInsertByLength = (maxLength, value = '', previousValue) => {
    if (!value)
        return value;
    const phone = (0, exports.removeSymbolsFromPhone)(value);
    const prev = (0, exports.removeSymbolsFromPhone)(previousValue);
    const phoneLength = phone.length;
    if (phone && phone.length > maxLength)
        return prev;
    if (phoneLength > maxLength && !value.match(/\(|\)|-|\s/gi))
        return previousValue;
    if (phone && !/\d/gi.test(phone[phoneLength - 1]))
        return;
    return phone;
};
const normalizePhoneBeforeInsertForUSA = (value, previousValue) => {
    if (!value)
        return value;
    const len = value.length;
    const format = !!value.match(/^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/);
    if (value[0] !== '(' && value[9] === '-' && len > 10)
        return parsePhoneBeforeShow(value, phone_1.USA_ISO);
    if (len > 14 && value.match(/\(|\)|-|\s/gi) && !format)
        return previousValue;
    if (!value.match(/\(|\)|-|\s/gi) && len > 10)
        return;
    if (value && !/\d|\(|\)|-|\s/gi.test(value[len - 1]))
        return;
    if (len === 10 && /\d{10}/gi.test(value)) {
        return parsePhoneBeforeShow(value, phone_1.USA_ISO);
    }
    if (len === 3 && value[0] !== '(') {
        return '(' + value + ') ';
    }
    else if (len === 4 && value[0] === '(' && previousValue.length === 3) {
        return value + ') ';
    }
    else if (len === 9 && (value[len - 1] !== '-' && previousValue.length === 8)) {
        return value + '-';
    }
    else {
        return value;
    }
};
const normalizePhoneBeforeInsert = (iso, value, previousValue) => {
    const phone = disableLetters(value);
    const phoneFormat = phone_1.formatByISO[iso];
    if (!phoneFormat) {
        iso = phone_1.USA_ISO;
        console.error('__For some reason phoneFormat didn\'t find__');
    }
    switch (iso) {
        case phone_1.ISOs[phone_1.USA_ISO]:
            return normalizePhoneBeforeInsertForUSA(phone, previousValue);
        default:
            return normalizePhoneBeforeInsertByLength(phoneFormat.max, phone, previousValue);
    }
};
exports.normalizePhoneBeforeInsert = normalizePhoneBeforeInsert;
const mapObjCountriesCodes = (objCountriesCodes) => {
    const arrCountriesCodes = [];
    for (const property in objCountriesCodes) {
        if (objCountriesCodes[property]) {
            arrCountriesCodes.push({ country: property, code: phone_1.ISO_CODE[property] });
        }
    }
    return arrCountriesCodes;
};
exports.mapObjCountriesCodes = mapObjCountriesCodes;
const parsePhoneBeforeSend = phone => {
    if (!phone)
        return;
    const parsedPhone = (0, exports.removeSymbolsFromPhone)(phone);
    const parsedPhoneLength = parsedPhone.length;
    if (parsedPhone.slice(0, 2) === '38' && parsedPhoneLength > 10) {
        return '+' + parsedPhone;
    }
    if (parsedPhone[0] === '1' && parsedPhoneLength === 11) {
        return '+' + parsedPhone;
    }
    if (parsedPhone.slice(0, 2) === '44' && parsedPhoneLength > 10) {
        return '+' + parsedPhone;
    }
    if (parsedPhone[0] === '+' && parsedPhoneLength === 12) {
        return parsedPhone;
    }
    if (parsedPhone.slice(0, 3) === '+34' && parsedPhoneLength >= 11) {
        return parsedPhone;
    }
    if (parsedPhoneLength === 10 && parsedPhone.slice(0, 2) !== phone_1.ISO_CODE.usa && parsedPhone[0] !== '+') {
        return `${phone_1.ISO_CODE.usa}${parsedPhone}`;
    }
    return parsedPhone;
};
exports.parsePhoneBeforeSend = parsePhoneBeforeSend;
//# sourceMappingURL=phone.js.map